<!--BANNER CAROUSEL-->
<section [ngClass]="carouselSectionCSS" id="banner-carousel-section-{{ id }}">
  <ngu-carousel #myCarousel [inputs]="carouselBanner" [dataSource]="carouselItems">
    <!--LEFT ARROW START-->
    <i
      NguCarouselPrev
      [ngClass]="carouselLeftArrowCSS"
      class="cursor icon white small"
      [style.opacity]="myCarousel.isFirst ? 0.5 : 1"></i>
    <!--LEFT ARROW START-->

    <!--CAROUSEL CONTENT START-->
    <ngu-item *nguCarouselDef="let item; index as i; let ani = animate">
      <div
        class="bannerStyle"
        [style.background-image]="'url(/assets/img/' + item.imageUrl + ')'"
        [ngClass]="bannerPositionsCss ? bannerPositionsCss : ''">
        <div class="wrapper billboard-wrapper">
          <div class="homepage-billboard-content">
            <div class="homepage-billboard-align">
              <h1>{{ item?.title }}</h1>
              <p class="large-text">{{ item?.description }}</p>
              <a
                id="banner-carousel-{{ item?.id }}"
                data-beyond-button-id="banner-carousel-{{ item?.id }}"
                class="btn btn-primary"
                routerLink="/{{ item?.route }}"
                (click)="sendGoogleAnalytics(item?.title, 'click', item?.cta)"
                routerLinkActive="active">
                {{ item?.cta }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ngu-item>
    <!--END CAROUSEL CONTENT-->

    <!--RIGHT ARROW START-->
    <i
      NguCarouselNext
      [ngClass]="carouselRightArrowCSS"
      class="cursor icon white small"
      [style.opacity]="myCarousel.isLast ? 0.5 : 1"></i>
    <!--END RIGHT ARROW-->

    <!--SLIDER DOTS START-->
    <ul class="myPoint cursor" NguCarouselPoint>
      <li
        *ngFor="
          let i of myCarousel.pointNumbers();
          let j = index;
          trackBy: trackByCarouselItemTitle
        "
        [ngClass]="i === myCarousel.activePoint ? carouselDotActiveCSS : ''"
        (click)="myCarousel.moveTo(i)"></li>
    </ul>
    <!--END SLIDER DOTS-->
  </ngu-carousel>
</section>
<!--END BANNER CAROUSEL-->
